var scroll_load = require( './scroll_load' );

var members_feed = (function( $ ) {

	var $form;

	var _init = function() {
		$form = $( '#feed-submission-box' );

		$form.on( 'submit', _ajax_submit );

		$form.find( '.add-items a' ).on( 'click', _show_action );
	};

	var _ajax_submit = function ( e ) {
		_loading( $form );

		var data = new FormData();

		data.append( 'feed_submission_file', document.getElementById( 'feed-submission-file' ).files[0] );
		data.append( 'action', 'insert_member_post' );
		data.append( 'insert_member_post_nonce', ScriptData.insert_member_post_nonce );
		data.append( 'form_data', $form.serialize() );

		$.ajax( {
			type: 'POST',
			url : ScriptData.ajaxurl,
			data : data,
			success : _ajax_response,
			processData : false,
			contentType : false
		} );

		e.preventDefault();
	};

	var _ajax_response = function( response ) {
		if ( response.success ) {
			_reset_submission_box();
			scroll_load.reset();
		}

		_loaded( $form );
	};

	var _loading = function( $elem ) {
		$elem.find( '.ajax-loader' ).fadeIn();
	};

	var _loaded = function( $elem ) {
		$elem.find( '.ajax-loader' ).fadeOut();
	};

	var _reset_submission_box = function() {
		$form[0].reset();
		$form.find( '.greyed' ).removeClass( 'greyed' );
		$form.find( '.shown' ).find( 'input' ).removeAttr( 'required' );
		$form.find( '.shown' ).removeClass( 'shown' );
	};

	var _show_action = function( e ) {
		if ( ! $( this ).hasClass( 'greyed' ) ) {
			var classname = $( this ).data( 'show' );

			$form.find( '.' + classname ).addClass( 'shown' );
			$form.find( '.' + classname ).find( 'input' ).attr( 'required', 'required' );
			$( this ).addClass( 'greyed' );
		}

		e.preventDefault();
	};

	if ( $( '#feed-submission-box' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = members_feed;